import type { NestedMap } from "./types";

const mapModifiersToDLS = (props: any, map: NestedMap) =>
  Object.keys(props)
    .filter(x => x.startsWith("$"))
    .map((modifier: string) => {
      const value: NestedMap = props[modifier];

      return typeof value === "string" ? map[modifier][value] : map[modifier];
    });

export default mapModifiersToDLS;
